import { useLocation } from 'src/router/hooks';

import { PULL_REQUEST_TABS, TabSelectedType } from '../pull-request-tabbed';

/**
 * Returns the currently selected tab based on the location.
 *
 * @return {TabSelectedType} The selected tab.
 */
export const useSelectedTab = (): TabSelectedType => {
  const location = useLocation();

  const segments = location.pathname.split('/');
  // Second pop is needed in case there is a trailing slash
  let selectedTab = segments.pop() || segments.pop();

  // if diff spec was provided, pop one more time to grab "diff" tab
  // ex: owner/slug/pull-requests/1/diff/aa..bb
  if (!PULL_REQUEST_TABS.includes(selectedTab as TabSelectedType)) {
    selectedTab = segments.pop();
  }

  if (
    selectedTab &&
    PULL_REQUEST_TABS.includes(selectedTab as TabSelectedType)
  ) {
    return selectedTab as TabSelectedType;
  }
  return 'overview';
};
